export default {
  getUser: state => state.user,
  getCams: state => {
    return Object.values(state.cams).map(cam => ({
      ...cam,
      views: state.views.filter(
        (view, i) => view.cams.indexOf(cam.id) > -1 && i != 0
      )
    }));
  },
  getCamIdFromCell: state => state.camIdFromCell,
  getViews: state => {
    return state.views.map(view => {
      return {
        ...view,
        cams: view.cams.map(
          idCamView => state.cams[idCamView] || { id: null, name: "Empty" }
        )
      };
    });
  },
  getActiveView: (state, getters) => {
    return (
      getters.getViews.find(view => view.id == state.route.params.viewId) ||
      null
    );
  },
  getMaps: state => state.maps,
  getCamsMap: state => mapObjects => {
    return mapObjects
      .filter(item => item.type == "CAM" && item.enabled !== false)
      .map(mapCam => {
        return {
          ...mapCam,
          ...state.cams[mapCam.id]
        };
      });
  },

  getLevelsMap: () => (mapObjects, group) => {
    return mapObjects
      .filter(item => item.type == "LEVEL")
      .map(item => {
        return { ...item, mapId: group.map.find(m => m.name == item.id).id };
      });
  },

  getMapById: (state, getters) => (groupId, mapId) => {
    let group = state.maps.find(group => group.id == groupId) || null;

    if (group) {
      let map = group.map.find(map => map.id == mapId);

      if (map) {
        const cams = getters.getCamsMap(map.objects);

        const levels = getters.getLevelsMap(map.objects, group);

        const mapObjs = map.objects.filter(
          item => item.type !== "LEVEL" && item.type !== "CAM"
        );

        return {
          ...map,
          cams,
          levels,
          mapObjs
        };
      }

      return null;
    }

    return null;
  },
  getAlarmCams: (state, getters) => {
    return getters.getCams.filter(cam => {
      return (
        ["DISARM_DETACHED", "DETACHED", "ALARMED"].includes(cam.status.state) ||
        cam.status.valid === false ||
        cam.status.focused === "false" ||
        cam.status.unblinded === "false"
      );
    });
  },
  getAlarmMaps: (state, getters) => {
    const alarmsCams = getters.getAlarmCams;
    let filterGroup = getters.getMaps.reduce((accGroup, group) => {
      const maps = group.map.reduce((accMap, map) => {
        const camObjs = map.objects.filter(camObj => {
          return !!alarmsCams.find(ac => ac.id === camObj.id);
        });
        if (camObjs.length) {
          return [
            ...accMap,
            {
              ...map,
              parent: 0,
              objects: camObjs
            }
          ];
        }
        return accMap;
      }, []);
      if (maps.length) {
        return [
          ...accGroup,
          {
            ...group,
            map: maps
          }
        ];
      }
      return accGroup;
    }, []);

    return filterGroup;
  },
  getActiveMap: (state, getters) => {
    return (
      getters.getMapById(
        state.route.params.mapGroupId,
        state.route.params.mapId
      ) || null
    );
  },
  getAlarmViews: state => state.views.slice(1),
  getAlarms: state => state.alarms,
  getLatestAlarms: state => state.alarms.slice(0, 6),
  getAlarmsActiveView: state => {
    if (state.route.query && state.route.query.view) {
      return (
        state.views.find(view => view.id == state.route.query.view) || null
      );
    }

    return null;
  },
  getAlarmsActiveViews: state => {
    if (state.route.query && state.route.query.view) {
      const queryView = state.route.query.view;
      const viewIds = queryView ? queryView.split(",") : null;
      const filterViews =
        (viewIds &&
          viewIds.length &&
          state.views &&
          state.views.length &&
          state.views.filter(({ id }) => viewIds.includes(id.toString()))) ||
        null;
      return filterViews && filterViews.length ? filterViews : null;
    }

    return null;
  },
  getMode: state => state.mode,
  getGrids: state => state.grids,
  getActiveGrid: state =>
    state.grids.find(grid => grid.value == state.grid) || null,
  getGrid: state => state.grid,
  getStream: state => state.stream,
  getUplodedVideos: state => state.uploadedVideos,
  getVideoState: state => state.videoState,
  getArchCnvEnabled: state => state.archCnvEnabled
};



// WEBPACK FOOTER //
// ./src/store/getters.js